import React from 'react';
import { accessor } from './DefaultCellRenderer';
import PropTypes from 'prop-types';

export function make(link) {
  function LinkCellRenderer({ row, head }) {
    const { label } = head;
    const value = accessor(row, head.field);

    return (
      <td
        className={`DynamicTableData__Cell__${(label || '').replace(' ', '_')}`}
      >
        <a href={link(value, head, row)}>{value}</a>
      </td>
    );
  }

  LinkCellRenderer.propTypes = {
    row: PropTypes.shape().isRequired,
    head: PropTypes.shape().isRequired,
  };

  return LinkCellRenderer;
}

const Interface = { make };
export default Interface;
